import React from "react";
import { cn } from "../../lib/utils";

export default function StatCard({
  title,
  value,
  badge,        // { text, tone, icon }
  trend,        // string
  description,
}) {
  const toneStyle = {
    positive: "bg-emerald-500/10 text-emerald-400",
    negative: "bg-red-500/10 text-red-400",
    neutral: "bg-neutral-500/10 text-gray-300",
  };

  return (
    <div className="rounded-2xl border border-border/60 bg-muted/40 p-5 shadow-sm transition-all hover:bg-muted/50 hover:scale-[1.01]">
      
      {/* Header */}
      <div className="flex items-center justify-between">
        <h3 className="text-[13px] font-medium text-gray-400">{title}</h3>

        {badge && (
          <span
            className={cn(
              "inline-flex items-center gap-1 text-[11px] px-1.5 py-0.5 rounded-md font-medium",
              toneStyle[badge.tone]
            )}
          >
            {badge.icon}
            {badge.text}
          </span>
        )}
      </div>

      {/* Value */}
      <div className="mt-2 text-[26px] font-semibold text-white leading-[1.1]">
        {value}
      </div>

      {/* Trend (설명 문장만) */}
      {trend && (
        <div className="mt-1 text-[13px] font-medium text-gray-200 leading-tight">
          {trend}
        </div>
      )}

      {/* Description */}
      {description && (
        <div className="mt-1 text-[12px] text-gray-500 leading-snug">
          {description}
        </div>
      )}
    </div>
  );
}